class EventJoinTargetError extends Error {
  constructor(message) {
    super(message);
    this.name = "EventJoinTargetError";
  }
}

function externalMeetingLink({ meetingLink, isLivestream }) {
  if (isLivestream) {
    return "";
  }

  return typeof meetingLink === "string" ? meetingLink.trim() : "";
}

function getJoinTarget(event, webBase) {
  const eventId = Number(event?.eventId);

  if (!Number.isInteger(eventId) || eventId <= 0) {
    throw new EventJoinTargetError(
      `Join Meeting has nowhere to send the viewer: the card's entity carries eventId=${JSON.stringify(event?.eventId)},`
        + " so there is no event page to open. The card rendered from an entity that never loaded.",
    );
  }

  const link = externalMeetingLink(event);
  if (link) {
    return { href: link, opensNewTab: true };
  }

  if (!webBase) {
    throw new EventJoinTargetError(
      `Join Meeting cannot open the page for event ${eventId}: links.web is empty in the general store,`
        + " so the destination's base URL is unknown.",
    );
  }

  return { href: `${String(webBase).replace(/\/+$/, "")}/event/${eventId}`, opensNewTab: false };
}

module.exports = {
  getJoinTarget,
  EventJoinTargetError,
};
